import { useMutation } from '@tanstack/react-query';
import api, { SynthesisResult } from '@/lib/api';

export interface SynthesizeInput {
  text: string;
  voiceId: string;
  stability?: number;
  similarityBoost?: number;
}

/**
 * Speech-synthesis mutation. See `useTranscription.ts` for the
 * `useMutation`-wrapped-as-named-hook convention used here.
 */
export function useSpeechSynthesis() {
  const mutation = useMutation<SynthesisResult, Error, SynthesizeInput>({
    mutationFn: (body) => api.synthesizeSpeech(body),
  });

  return {
    synthesize: async (body: SynthesizeInput): Promise<SynthesisResult | null> => {
      try {
        return await mutation.mutateAsync(body);
      } catch {
        return null;
      }
    },
    synthesizing: mutation.isPending,
    audioUrl: mutation.data?.downloadUrl ?? null,
    fileId: mutation.data?.fileId ?? null,
    error: mutation.error?.message ?? null,
    reset: mutation.reset,
  };
}
